import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { environment } from '@src/environments/environment';
import { InjectionTokens } from '@src/serviceTokens';
import { map } from 'rxjs';
import { LoginService } from '../../services/login.service';

export const PermissionGuard = (allowedPermissions: string[] | string): CanActivateFn => {
  if (typeof allowedPermissions === 'string') {
    allowedPermissions = [allowedPermissions];
  }

  return () => {
    const loginService: LoginService = inject(InjectionTokens.get(LoginService));
    return loginService.permissions.pipe(
      // For every allowedPermission, check if the user has the permission
      map(permissions => {
        const authorized = allowedPermissions.every(permission => permissions.includes(permission));
        if (!authorized) {
          if (!environment.production) {
            console.error('User does not have the required permissions. Contact Colbi Support for assistance.');
          }
        }
        return authorized;
      })
    );
  };
};
